export default "__VITE_PUBLIC_ASSET__ee6dd9d1__"